export const formatMemberNumber = (memberNumber?: string): string => {
  if (!memberNumber) {
    return '';
  } else if (memberNumber.length !== 9 || /^\d+$/.test(memberNumber) === false) {
    return memberNumber;
  }

  return memberNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
